import React, { useEffect, useState } from 'react';
import { FaStar } from 'react-icons/fa';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const depoimentos = [
  {
    nome: 'Camila',
    empresa: 'Academia',
    texto: 'A Monise desenvolveu o sistema de gestão e o site para minha academia. O trabalho foi impecável! O sistema facilitou muito a gestão dos alunos e pagamentos, e o site trouxe mais visibilidade para o negócio. Profissionalismo, atenção aos detalhes e sempre disponível para ajustes. Super recomendo!',
    avaliacao: 5,
  },
  {
    nome: 'Rosenal',
    empresa: 'Serviços de Jardinagem',
    texto: 'Contratei a Monise para desenvolver o aplicativo de gestão para minha empresa. Ficou excelente! O app organizou completamente meus agendamentos, clientes e serviços. A interface é intuitiva e fácil de usar. A Monise foi muito atenciosa durante todo o processo e entregou tudo dentro do prazo. Estou muito satisfeito!',
    avaliacao: 5,
  },
  {
    nome: 'Renata',
    empresa: 'Clínica Odontológica',
    texto: 'A Monise desenvolveu meu site profissional e o resultado superou todas as expectativas! O site ficou moderno, elegante e transmite confiança, exatamente o que eu precisava. A comunicação foi excelente em todas as etapas e o prazo foi cumprido perfeitamente. Recomendo de olhos fechados!',
    avaliacao: 5,
  },
];

const DepoimentoCard = ({ depoimento, animate = true }) => (
  <div
    className={`${animate ? 'gsap-reveal ' : ''}group p-8 rounded-2xl bg-cream dark:bg-dark-bg border border-brown/10 dark:border-burnt/10 hover:border-burnt/30 transition-all duration-500 hover:shadow-premium dark:hover:shadow-premium-dark hover:-translate-y-1`}
  >
    <div className="flex mb-4">
      {[...Array(depoimento.avaliacao)].map((_, i) => (
        <FaStar key={i} className="text-burnt text-lg" />
      ))}
    </div>
    <p className="text-dark/90 dark:text-cream/90 mb-6 leading-relaxed italic font-body">
      &ldquo;{depoimento.texto}&rdquo;
    </p>
    <div className="border-t border-brown/10 dark:border-burnt/10 pt-4">
      <p className="font-heading font-semibold text-dark dark:text-cream">{depoimento.nome}</p>
      <p className="text-sm text-dark/60 dark:text-cream/60">{depoimento.empresa}</p>
    </div>
  </div>
);

const Depoimentos = () => {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia('(max-width: 767px)').matches : false
  );
  const [visibleCount, setVisibleCount] = useState(1);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    const update = () => {
      setIsMobile(mq.matches);
      if (!mq.matches) setVisibleCount(1);
    };
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  useEffect(() => {
    const timer = window.setTimeout(() => ScrollTrigger.refresh(), 50);
    return () => window.clearTimeout(timer);
  }, [visibleCount, isMobile]);

  const visibleDepoimentos = isMobile
    ? depoimentos.slice(0, visibleCount)
    : depoimentos;
  const hasMore = isMobile && visibleCount < depoimentos.length;

  return (
    <section id="depoimentos" className="py-24 md:py-32 bg-white dark:bg-dark-surface transition-colors duration-500">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16 gsap-reveal">
          <p className="text-burnt font-heading font-semibold uppercase tracking-wider text-sm mb-4">
            Depoimentos
          </p>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-dark dark:text-cream mb-4">
            O que meus clientes dizem
          </h2>
          <p className="text-xl text-dark/70 dark:text-cream/70 max-w-2xl mx-auto font-body">
            Resultados reais de quem confiou no meu trabalho
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {visibleDepoimentos.map((depoimento, index) => (
            <DepoimentoCard
              key={depoimento.nome}
              depoimento={depoimento}
              animate={!(isMobile && index > 0)}
            />
          ))}
        </div>

        {hasMore && (
          <div className="mt-8 flex justify-center md:hidden">
            <button
              type="button"
              onClick={() => setVisibleCount((count) => count + 1)}
              className="min-h-[44px] px-8 py-3 rounded-xl border border-burnt/40 text-burnt font-heading font-semibold hover:bg-burnt hover:text-white transition-colors"
              data-cursor="pointer"
            >
              Ver mais
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Depoimentos;
